export default __webpack_public_path__ + "/dist/images/492351.png";